import React from 'react';
import { Link } from 'gatsby-plugin-react-i18next';
import Label from '@components/Label';
import { SubMenuItem } from '../SubMenuItem';
import * as styles from './style.module.scss';
import * as subMenuItemStyles from '../SubMenuItem/style.module.scss';

const { 
  subMenuMobileView,
  subMenuMobileView__linkContainer,
  subMenuMobileView__ctaSection,
  subMenuMobileView__contentSection,
  subMenu__layout,
} = styles;

const { subMenuItem__label } = subMenuItemStyles;

export const SubMenuWithBack = ({
  submenuData,
  goBack,
  goToSubmenu,
}) => {
  const { submenus = [], iconLink, ctas = [] } = submenuData;

  return (
    <div className={subMenuMobileView}>

      {/* Second-level submenu items */}
      {submenus.map((submenu, index) => {
        const hasThirdLevel = Array.isArray(submenu.submenus) && submenu.submenus.length > 0;

        return (
          <div key={index}>
            {/* Render second-level item */}
            <SubMenuItem {...submenu} />

            {/* Render third-level children as plain links */}
            {hasThirdLevel && (
              <div className={styles.subMenuLevel3}>
                {submenu.submenus.map((third, i) =>
                  third.href ? (
                    <Link key={i} to={third.href} className={styles.subMenuLevel3Link}>
                      {third.label}
                    </Link>
                  ) : (
                    <span key={i} className={styles.subMenuLevel3Link}>
                      {third.label}
                    </span>
                  )
                )}
              </div>
            )}
          </div>
        );
      })}

      {/* Optional icon link section */}
      {iconLink && (
        <div className={subMenuMobileView__linkContainer}>
          {iconLink}
        </div>
      )}

      {/* CTA section (mobile-friendly) */}
      {ctas.length > 0 && (
        <div className={subMenuMobileView__ctaSection}>
          {ctas.map((cta, index) => (
            <div key={`cta-${index}`} className={styles.subMenuCtaItem}>
              {cta.label && (
                <Label classes={subMenuItem__label}>{cta.label}</Label>
              )}
              {cta.content}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
